import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import KitchenImg from "../assets/Kitchen Renovation.jpeg";
import WashroomImg from "../assets/Washroom Renovation.jpeg";
import FlooringImg from "../assets/Flooring & Stains.jpeg";
import BasementImg from "../assets/Basement Renovations.jpg";
import PaintingImg from "../assets/Painting.jpg";
import DemolitionImg from "../assets/Demolitions.jpg";
import PlumbingImg from "../assets/Plumbing.jpg";
import ElectricalImg from "../assets/Electrical.png";
import "./ServicesSection.css";

const ServicesSection = () => {
  const services = [
    {
      title: "Kitchen Renovation",
      img: KitchenImg,
      text: "Transform your kitchen into a modern, functional space. We handle layout redesign, cabinet upgrades, countertop installation, and smart storage solutions. Enjoy a stylish kitchen that enhances both cooking and living experiences.",
    },
    {
      title: "Washroom Renovation",
      img: WashroomImg,
      text: "Upgrade your bathroom with elegant fixtures and efficient layouts. Our services include tiling, sanitary installation, lighting, and waterproofing. Create a relaxing, spa-like environment right in your home.",
    },
    {
      title: "Flooring & Stains",
      img: FlooringImg,
      text: "Enhance the look of your home with premium flooring options. We specialize in hardwood, laminate, tile, and epoxy flooring. Our staining and finishing services ensure durability and a polished finish.",
    },
    {
      title: "Basement Renovations",
      img: BasementImg,
      text: "Transform your basement into a livable and functional area. We handle flooring, insulation, lighting, and storage solutions. Perfect for a home theater, guest room, or personal workspace.",
    },
    {
      title: "Painting",
      img: PaintingImg,
      text: "Bring life to your interiors with professional painting services. We offer wall painting, ceiling finishes, and decorative techniques. Use colors and textures that reflect your style and personality.",
    },
    {
      title: "Demolitions",
      img: DemolitionImg,
      text: "Safe and efficient demolition services for remodeling projects. We handle structural removal, debris management, and site preparation. Ensure a clean and secure environment for your new construction.",
    },
    {
      title: "Plumbing",
      img: PlumbingImg,
      text: "Reliable plumbing solutions for installations, repairs, and maintenance. We manage water supply lines, drainage systems, and fixture installations. Keep your home running smoothly with professional plumbing.",
    },
    {
      title: "Electrical",
      img: ElectricalImg,
      text: "Professional electrical services for installations, repairs, and upgrades. We handle wiring, lighting, panel upgrades, and safety inspections. Ensure your home is safe, functional, and energy-efficient.",
    },
  ];

  return (
    <section id="services" className="services-section py-5 text-center">
      <Container>
        <h2 className="fw-bold mb-5">Our Services</h2>
        <Row className="g-4">
          {services.map((service, index) => (
            <Col key={index} xs={12} sm={6} lg={4}>
              <Card className="service-card h-100 border-0 text-center">
                <LazyLoadImage
                  src={service.img}
                  alt={service.title}
                  className="service-card-img mb-3"
                  effect="blur" // Smooth blur effect while loading
                />
                <Card.Body>
                  <Card.Title className="fw-semibold">
                    {service.title}
                  </Card.Title>
                  <Card.Text>{service.text}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ServicesSection;
